import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Keep descriptions for extra information`}</h3>
    <p>{`Users sometimes skip descriptions so make sure there’s nothing essential in them.
If you need to say something really important,
use an informational `}<a parentName="p" {...{
        "href": "/components/information/alert/"
      }}>{`alert`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      